import { lazy } from 'react';

const Login = lazy(() => import('./Login'));
const ResetPassword = lazy(() => import('./ResetPassword'));
const ForgetPassword = lazy(() => import('./ForgetPassword'));
const Emailverification = lazy(() => import('./Emailverification'));
const ExternalLogin = lazy(() => import('./ExternalLogin'));

export {
  Login,
  ResetPassword,
  ForgetPassword,
  Emailverification,
  ExternalLogin,
};
